import { productFamilyCodes } from 'types/productFamilyCodes';

const subscriptionProductFamilies = [productFamilyCodes.PUB];

export default subscriptionProductFamilies;
